import React, { useState, useCallback, useMemo } from 'react';

// ── Predefined Layout Templates ─────────────────────────────────────────────
// Cells are defined WITHOUT gaps (pure proportional layout, 0-100%).
// Gaps are applied at runtime by applyGap() based on canvas aspect ratio.

const LAYOUT_DEFS = [
  // ── 1 Foto ──
  { id: '1a', count: 1, cells: [{ x: 0, y: 0, w: 100, h: 100 }] },
  { id: '1b', count: 1, cells: [{ x: 10, y: 5, w: 80, h: 90 }] },
  // ── 2 Fotos ──
  { id: '2a', count: 2, cells: [
    { x: 0, y: 0, w: 50, h: 100 },
    { x: 50, y: 0, w: 50, h: 100 },
  ]},
  { id: '2b', count: 2, cells: [
    { x: 0, y: 0, w: 100, h: 50 },
    { x: 0, y: 50, w: 100, h: 50 },
  ]},
  { id: '2c', count: 2, cells: [
    { x: 0, y: 0, w: 65, h: 100 },
    { x: 65, y: 0, w: 35, h: 100 },
  ]},
  // ── 3 Fotos ──
  { id: '3a', count: 3, cells: [
    { x: 0, y: 0, w: 50, h: 100 },
    { x: 50, y: 0, w: 50, h: 50 },
    { x: 50, y: 50, w: 50, h: 50 },
  ]},
  { id: '3b', count: 3, cells: [
    { x: 0, y: 0, w: 33.33, h: 100 },
    { x: 33.33, y: 0, w: 33.34, h: 100 },
    { x: 66.67, y: 0, w: 33.33, h: 100 },
  ]},
  { id: '3c', count: 3, cells: [
    { x: 0, y: 0, w: 100, h: 50 },
    { x: 0, y: 50, w: 50, h: 50 },
    { x: 50, y: 50, w: 50, h: 50 },
  ]},
  { id: '3d', count: 3, cells: [
    { x: 0, y: 0, w: 50, h: 50 },
    { x: 50, y: 0, w: 50, h: 50 },
    { x: 0, y: 50, w: 100, h: 50 },
  ]},
  // ── 4 Fotos ──
  { id: '4a', count: 4, cells: [
    { x: 0, y: 0, w: 50, h: 50 },
    { x: 50, y: 0, w: 50, h: 50 },
    { x: 0, y: 50, w: 50, h: 50 },
    { x: 50, y: 50, w: 50, h: 50 },
  ]},
  { id: '4b', count: 4, cells: [
    { x: 0, y: 0, w: 60, h: 60 },
    { x: 60, y: 0, w: 40, h: 30 },
    { x: 60, y: 30, w: 40, h: 30 },
    { x: 0, y: 60, w: 100, h: 40 },
  ]},
  { id: '4c', count: 4, cells: [
    { x: 0, y: 0, w: 33.33, h: 100 },
    { x: 33.33, y: 0, w: 33.34, h: 50 },
    { x: 33.33, y: 50, w: 33.34, h: 50 },
    { x: 66.67, y: 0, w: 33.33, h: 100 },
  ]},
  { id: '4d', count: 4, cells: [
    { x: 0, y: 0, w: 100, h: 60 },
    { x: 0, y: 60, w: 33.33, h: 40 },
    { x: 33.33, y: 60, w: 33.34, h: 40 },
    { x: 66.67, y: 60, w: 33.33, h: 40 },
  ]},
  // ── 5 Fotos ──
  { id: '5a', count: 5, cells: [
    { x: 0, y: 0, w: 50, h: 33.33 },
    { x: 50, y: 0, w: 50, h: 33.33 },
    { x: 0, y: 33.33, w: 33.33, h: 33.34 },
    { x: 33.33, y: 33.33, w: 33.34, h: 33.34 },
    { x: 66.67, y: 33.33, w: 33.33, h: 33.34 },
  ]},
  { id: '5b', count: 5, cells: [
    { x: 0, y: 0, w: 60, h: 60 },
    { x: 60, y: 0, w: 40, h: 30 },
    { x: 60, y: 30, w: 40, h: 30 },
    { x: 0, y: 60, w: 50, h: 40 },
    { x: 50, y: 60, w: 50, h: 40 },
  ]},
  { id: '5c', count: 5, cells: [
    { x: 0, y: 0, w: 50, h: 50 },
    { x: 50, y: 0, w: 50, h: 50 },
    { x: 0, y: 50, w: 33.33, h: 50 },
    { x: 33.33, y: 50, w: 33.34, h: 50 },
    { x: 66.67, y: 50, w: 33.33, h: 50 },
  ]},
  // ── 6 Fotos ──
  { id: '6a', count: 6, cells: [
    { x: 0, y: 0, w: 33.33, h: 50 },
    { x: 33.33, y: 0, w: 33.34, h: 50 },
    { x: 66.67, y: 0, w: 33.33, h: 50 },
    { x: 0, y: 50, w: 33.33, h: 50 },
    { x: 33.33, y: 50, w: 33.34, h: 50 },
    { x: 66.67, y: 50, w: 33.33, h: 50 },
  ]},
  { id: '6b', count: 6, cells: [
    { x: 0, y: 0, w: 50, h: 66 },
    { x: 50, y: 0, w: 25, h: 33 },
    { x: 75, y: 0, w: 25, h: 33 },
    { x: 50, y: 33, w: 50, h: 33 },
    { x: 0, y: 66, w: 50, h: 34 },
    { x: 50, y: 66, w: 50, h: 34 },
  ]},
  { id: '6c', count: 6, cells: [
    { x: 0, y: 0, w: 66, h: 50 },
    { x: 66, y: 0, w: 34, h: 50 },
    { x: 0, y: 50, w: 25, h: 50 },
    { x: 25, y: 50, w: 25, h: 50 },
    { x: 50, y: 50, w: 25, h: 50 },
    { x: 75, y: 50, w: 25, h: 50 },
  ]},
  // ── 7 Fotos ──
  { id: '7a', count: 7, cells: [
    { x: 0, y: 0, w: 50, h: 33.33 },
    { x: 50, y: 0, w: 50, h: 33.33 },
    { x: 0, y: 33.33, w: 33.33, h: 33.34 },
    { x: 33.33, y: 33.33, w: 33.34, h: 33.34 },
    { x: 66.67, y: 33.33, w: 33.33, h: 33.34 },
    { x: 0, y: 66.67, w: 50, h: 33.33 },
    { x: 50, y: 66.67, w: 50, h: 33.33 },
  ]},
  { id: '7b', count: 7, cells: [
    { x: 0, y: 0, w: 60, h: 50 },
    { x: 60, y: 0, w: 40, h: 25 },
    { x: 60, y: 25, w: 40, h: 25 },
    { x: 0, y: 50, w: 25, h: 50 },
    { x: 25, y: 50, w: 25, h: 50 },
    { x: 50, y: 50, w: 25, h: 50 },
    { x: 75, y: 50, w: 25, h: 50 },
  ]},
  // ── 8 Fotos ──
  { id: '8a', count: 8, cells: [
    { x: 0, y: 0, w: 25, h: 50 },
    { x: 25, y: 0, w: 25, h: 50 },
    { x: 50, y: 0, w: 25, h: 50 },
    { x: 75, y: 0, w: 25, h: 50 },
    { x: 0, y: 50, w: 25, h: 50 },
    { x: 25, y: 50, w: 25, h: 50 },
    { x: 50, y: 50, w: 25, h: 50 },
    { x: 75, y: 50, w: 25, h: 50 },
  ]},
  { id: '8b', count: 8, cells: [
    { x: 0, y: 0, w: 50, h: 50 },
    { x: 50, y: 0, w: 25, h: 25 },
    { x: 75, y: 0, w: 25, h: 25 },
    { x: 50, y: 25, w: 25, h: 25 },
    { x: 75, y: 25, w: 25, h: 25 },
    { x: 0, y: 50, w: 33.33, h: 50 },
    { x: 33.33, y: 50, w: 33.34, h: 50 },
    { x: 66.67, y: 50, w: 33.33, h: 50 },
  ]},
  // ── 9 Fotos ──
  { id: '9a', count: 9, cells: (() => {
    const c = [];
    for (let r = 0; r < 3; r++)
      for (let col = 0; col < 3; col++)
        c.push({ x: col * 33.33 + (col === 2 ? 0.01 : 0), y: r * 33.33 + (r === 2 ? 0.01 : 0), w: 33.33 + (col === 1 ? 0.01 : 0), h: 33.33 + (r === 1 ? 0.01 : 0) });
    return c;
  })()},
  // ── 12 Fotos ──
  { id: '12a', count: 12, cells: (() => {
    const c = [];
    for (let r = 0; r < 3; r++)
      for (let col = 0; col < 4; col++)
        c.push({ x: col * 25, y: r * 33.33 + (r === 2 ? 0.01 : 0), w: 25, h: 33.33 + (r === 1 ? 0.01 : 0) });
    return c;
  })()},
];

/**
 * Apply uniform gap (in mm) to gap-free layout cells.
 * Each internal edge (not touching canvas boundary) gets gap/2 inset.
 * gxPct/gyPct ensure equal pixel spacing regardless of canvas aspect ratio.
 */
function applyGap(cells, widthCm, heightCm, gapMm) {
  if (gapMm <= 0) return cells;
  const gapCm = gapMm / 10;
  const gxPct = (gapCm / widthCm) * 100;   // gap as % of width
  const gyPct = (gapCm / heightCm) * 100;   // gap as % of height

  return cells.map(cell => {
    const isLeft   = cell.x < 0.5;
    const isTop    = cell.y < 0.5;
    const isRight  = (cell.x + cell.w) > 99.5;
    const isBottom = (cell.y + cell.h) > 99.5;

    const gapL = isLeft   ? 0 : gxPct / 2;
    const gapR = isRight  ? 0 : gxPct / 2;
    const gapT = isTop    ? 0 : gyPct / 2;
    const gapB = isBottom ? 0 : gyPct / 2;

    return {
      x: cell.x + gapL,
      y: cell.y + gapT,
      w: cell.w - gapL - gapR,
      h: cell.h - gapT - gapB,
    };
  });
}

// For thumbnails, apply a small visual gap
const g = 1.5;
const LAYOUT_TEMPLATES = LAYOUT_DEFS.map(tpl => ({
  ...tpl,
  cells: applyGap(tpl.cells, 100, 66, 4), // visual gap for 3:2 thumbnails
}));

// ── Layout thumbnail component ───────────────────────────────────────────────
function LayoutThumb({ layout, selected, onClick }) {
  const vW = 100, vH = 66; // 3:2 aspect for thumbnails
  return (
    <button
      onClick={onClick}
      className={`rounded-lg border-2 overflow-hidden transition-all hover:shadow-md ${
        selected ? 'border-blue-500 shadow-md ring-2 ring-blue-200' : 'border-gray-200 hover:border-gray-300'
      }`}
      style={{ width: '100%', aspectRatio: '3/2', padding: 0 }}
    >
      <svg width="100%" height="100%" viewBox={`0 0 ${vW} ${vH}`} preserveAspectRatio="none">
        <rect width={vW} height={vH} fill="#f9fafb" />
        {layout.cells.map((cell, i) => (
          <rect
            key={i}
            x={cell.x * vW / 100}
            y={cell.y * vH / 100}
            width={cell.w * vW / 100}
            height={cell.h * vH / 100}
            fill="#c8ced6"
            rx="1"
          />
        ))}
      </svg>
    </button>
  );
}

// ── Number preview ───────────────────────────────────────────────────────────
function NumberPreview({ number, showOutline }) {
  if (!number || number.length === 0) {
    return (
      <div className="flex items-center justify-center h-[120px] bg-gray-50 rounded-lg border border-gray-200">
        <span className="text-xs text-gray-400">Zahl eingeben...</span>
      </div>
    );
  }
  return (
    <div className="relative h-[120px] bg-gray-50 rounded-lg border border-gray-200 overflow-hidden flex items-center justify-center">
      <svg width="100%" height="100%" viewBox="0 0 300 150" preserveAspectRatio="xMidYMid meet">
        <defs>
          <pattern id="gp" width="18" height="18" patternUnits="userSpaceOnUse">
            <rect x="1" y="1" width="16" height="16" fill="#c8ced6" stroke="#fff" strokeWidth="1" />
          </pattern>
          <clipPath id="nc">
            <text x="150" y="110" textAnchor="middle" fontSize="120" fontFamily="Impact, Arial Black, sans-serif" fontWeight="900">{number}</text>
          </clipPath>
        </defs>
        <rect x="0" y="0" width="300" height="150" fill="url(#gp)" clipPath="url(#nc)" />
        {showOutline && (
          <text x="150" y="110" textAnchor="middle" fontSize="120" fontFamily="Impact, Arial Black, sans-serif" fontWeight="900" fill="none" stroke="#333" strokeWidth="2.5" strokeLinejoin="round">{number}</text>
        )}
      </svg>
    </div>
  );
}

// ── Birthday/Anniversary sayings ─────────────────────────────────────────────
const SAYINGS = {
  '18': [
    'Endlich 18 – das Abenteuer beginnt!',
    '18 Jahre voller wunderbarer Momente',
    'Willkommen im Club der Erwachsenen!',
    '18 – jung, wild und wunderbar',
    'Das Beste kommt erst noch – Happy 18!',
  ],
  '25': [
    '25 Jahre – ein Vierteljahrhundert voller Leben',
    'Silbernes Jubiläum – 25 wundervolle Jahre',
    '25 Jahre voller Erinnerungen und Freude',
    'Ein Vierteljahrhundert – und es war großartig!',
    '25 Jahre gemeinsam – was für eine Reise!',
  ],
  '30': [
    '30 – das beste Alter beginnt jetzt!',
    'Dreißig und fabelhaft',
    '30 Jahre voller Leben und Lachen',
    'Willkommen in den besten Jahren!',
    '30 tolle Jahre – auf die nächsten 30!',
  ],
  '40': [
    '40 ist das neue 30!',
    'Fabelhaft mit 40',
    '40 Jahre – die Hälfte ist geschafft, das Beste kommt noch!',
    '40 wunderbare Jahre voller Erinnerungen',
    'Mit 40 fängt das Leben erst richtig an!',
  ],
  '50': [
    '50 tolle Jahre',
    '50 und kein bisschen leise!',
    'Ein halbes Jahrhundert voller Lebensfreude',
    '50 Jahre – das Beste aus zwei Welten',
    'Goldene 50 – eine Feier des Lebens',
  ],
  '60': [
    '60 Jahre jung – und voller Energie!',
    '60 wundervolle Jahre',
    'Das Leben beginnt mit 60!',
    '60 Jahre voller Weisheit und Freude',
    'Diamantene 60 – strahlend wie eh und je',
  ],
  default: [
    'Herzlichen Glückwunsch!',
    'Alles Gute zum Geburtstag!',
    'Ein besonderer Tag für einen besonderen Menschen',
    'Feiere das Leben!',
    'Auf viele weitere wunderbare Jahre!',
  ],
};

function getSaying(number) {
  const sayings = SAYINGS[number] || SAYINGS.default;
  return sayings[Math.floor(Math.random() * sayings.length)];
}

// ── Filter tabs ──────────────────────────────────────────────────────────────
const FILTER_TABS = [
  { id: 'all', label: 'Alle' },
  { id: '1-3', label: '1-3' },
  { id: '4-6', label: '4-6' },
  { id: '7-10', label: '7-10' },
  { id: '11+', label: '11+' },
];

function filterLayouts(filter) {
  if (filter === 'all') return LAYOUT_TEMPLATES;
  if (filter === '1-3') return LAYOUT_TEMPLATES.filter(l => l.count >= 1 && l.count <= 3);
  if (filter === '4-6') return LAYOUT_TEMPLATES.filter(l => l.count >= 4 && l.count <= 6);
  if (filter === '7-10') return LAYOUT_TEMPLATES.filter(l => l.count >= 7 && l.count <= 10);
  if (filter === '11+') return LAYOUT_TEMPLATES.filter(l => l.count >= 11);
  return LAYOUT_TEMPLATES;
}

// ── Main Component ───────────────────────────────────────────────────────────
function CollagePanel({ canvasManager, onClose }) {
  const [activeTab, setActiveTab] = useState('layouts');
  const [filter, setFilter] = useState('all');
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [gapMm, setGapMm] = useState(3); // gap in mm (default 3mm)
  const [numberInput, setNumberInput] = useState('');
  const [showOutline, setShowOutline] = useState(false);
  const [saying, setSaying] = useState('');
  const [sayingEdited, setSayingEdited] = useState(false);

  const filteredLayouts = useMemo(() => filterLayouts(filter), [filter]);

  // Group layouts by count
  const groupedLayouts = useMemo(() => {
    const groups = {};
    filteredLayouts.forEach(l => {
      if (!groups[l.count]) groups[l.count] = [];
      groups[l.count].push(l);
    });
    return Object.entries(groups).sort((a, b) => Number(a[0]) - Number(b[0]));
  }, [filteredLayouts]);

  const handleCreateLayout = useCallback(() => {
    if (!canvasManager || !selectedLayout) return;
    const tpl = LAYOUT_DEFS.find(t => t.id === selectedLayout);
    if (!tpl) return;

    // Apply uniform gap based on canvas dimensions
    const widthCm = canvasManager.widthCm || 100;
    const heightCm = canvasManager.heightCm || 50;
    const gappedCells = applyGap(tpl.cells, widthCm, heightCm, gapMm);

    const layout = gappedCells.map((cell, i) => ({
      x: cell.x,
      y: cell.y,
      width: cell.w,
      height: cell.h,
      shape: 'rect',
      rotation: 0,
      label: String(i + 1),
    }));
    canvasManager.addCollage(layout);
    onClose();
  }, [canvasManager, selectedLayout, gapMm, onClose]);

  const handleCreateNumber = useCallback(() => {
    if (!canvasManager || !numberInput) return;
    const result = canvasManager.generateNumberLayout(numberInput, 'rect');
    canvasManager.addCollage(result, { showOutline });
    // Add saying as editable text below the number
    if (saying && saying.trim()) {
      canvasManager.addText(saying.trim(), {
        fontSize: Math.round(canvasManager.vHeight * 0.06),
        fontFamily: "'Dancing Script', 'Brush Script MT', cursive",
        fontWeight: 'normal',
        fontStyle: 'italic',
        fill: '#333333',
        textAlign: 'center',
        left: canvasManager.vWidth * 0.55,
        top: canvasManager.vHeight * 0.88,
      });
    }
    onClose();
  }, [canvasManager, numberInput, showOutline, saying, onClose]);

  return (
    <div
      className="fixed z-[100] bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden animate-slideInLeft flex flex-col"
      style={{ left: 84, top: 80, width: 360, maxHeight: '85vh' }}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 pt-3 pb-2">
        <h3 className="text-sm font-semibold text-gray-800">Fotocollage</h3>
        <button onClick={onClose} className="w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full text-lg leading-none">&times;</button>
      </div>

      {/* Tabs */}
      <div className="px-4 border-b border-gray-200">
        <div className="flex gap-4">
          {[
            { id: 'layouts', label: 'Layouts' },
            { id: 'number', label: 'Zahlencollage' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`relative pb-2 text-xs font-medium transition-colors ${
                activeTab === tab.id ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
              {activeTab === tab.id && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full" />}
            </button>
          ))}
        </div>
      </div>

      {/* Scrollable content */}
      <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 160px)' }}>

        {/* ── Layouts Tab ── */}
        {activeTab === 'layouts' && (
          <div className="p-4">
            {/* Filter pills */}
            <div className="flex items-center gap-1 mb-4">
              <span className="text-[11px] text-gray-500 font-medium mr-1">Bildanzahl</span>
              {FILTER_TABS.map(f => (
                <button
                  key={f.id}
                  onClick={() => setFilter(f.id)}
                  className={`px-2.5 py-1 rounded-full text-[11px] font-medium transition-all ${
                    filter === f.id
                      ? 'bg-gray-700 text-white'
                      : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>

            {/* Layout groups */}
            {groupedLayouts.map(([count, layouts]) => (
              <div key={count} className="mb-4">
                <h4 className="text-xs font-semibold text-gray-700 mb-2">{count} {Number(count) === 1 ? 'Foto' : 'Fotos'}</h4>
                <div className="grid grid-cols-3 gap-2">
                  {layouts.map(layout => (
                    <LayoutThumb
                      key={layout.id}
                      layout={layout}
                      selected={selectedLayout === layout.id}
                      onClick={() => setSelectedLayout(layout.id)}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── Number Tab ── */}
        {activeTab === 'number' && (
          <div className="p-4 space-y-4">
            {/* Quick presets */}
            <div>
              <label className="text-[11px] text-gray-500 mb-1.5 block">Schnellauswahl</label>
              <div className="flex flex-wrap gap-1.5">
                {['18', '25', '30', '40', '50', '60'].map(num => (
                  <button
                    key={num}
                    onClick={() => { setNumberInput(num); if (!sayingEdited) setSaying(getSaying(num)); }}
                    className={`px-3 py-1.5 rounded-lg text-xs font-medium border transition-all ${
                      numberInput === num
                        ? 'border-blue-500 bg-blue-50 text-blue-600'
                        : 'border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50'
                    }`}
                  >
                    {num}
                  </button>
                ))}
              </div>
            </div>

            {/* Custom number input */}
            <div>
              <label className="text-[11px] text-gray-500 mb-1 block">Eigene Zahl</label>
              <input
                type="text"
                value={numberInput}
                onChange={(e) => { const v = e.target.value.replace(/[^0-9]/g, ''); setNumberInput(v); if (!sayingEdited && v) setSaying(getSaying(v)); }}
                placeholder="z.B. 50, 18, 30"
                className="selenny-input text-xs w-full"
              />
            </div>

            {/* Outline toggle */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={showOutline}
                onChange={(e) => setShowOutline(e.target.checked)}
                className="w-4 h-4 rounded border-gray-300 text-blue-600 accent-blue-600"
              />
              <span className="text-xs text-gray-600">Umrandung anzeigen</span>
            </label>

            {/* Preview */}
            <NumberPreview number={numberInput} showOutline={showOutline} />

            {/* Saying suggestion */}
            {numberInput && (
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <label className="text-[11px] text-gray-500 font-medium">Spruch-Vorschlag</label>
                  <button
                    onClick={() => { setSaying(getSaying(numberInput)); setSayingEdited(false); }}
                    className="flex items-center gap-1 text-[11px] text-blue-600 hover:text-blue-700 font-medium"
                    title="Neuen Spruch vorschlagen"
                  >
                    <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                      <path d="M21 12a9 9 0 1 1-9-9"/><path d="M21 3v6h-6"/>
                    </svg>
                    Neuer Spruch
                  </button>
                </div>
                <textarea
                  value={saying}
                  onChange={(e) => { setSaying(e.target.value); setSayingEdited(true); }}
                  rows={2}
                  className="selenny-input text-xs w-full resize-none"
                  placeholder="Spruch eingeben oder generieren lassen..."
                />
                <p className="text-[10px] text-gray-400">Text kann frei geändert werden. Wird als bearbeitbarer Text auf die Bühne gelegt.</p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Sticky footer — always visible */}
      <div className="border-t border-gray-200 bg-white px-4 py-3 shrink-0">
        {activeTab === 'layouts' && (
          <>
            {/* Gap slider */}
            <div className="mb-3">
              <div className="flex items-center justify-between mb-1">
                <span className="text-[11px] text-gray-500 font-medium">Abstand zwischen Bildern</span>
                <span className="text-[11px] font-semibold text-gray-700">{gapMm} mm</span>
              </div>
              <input
                type="range"
                min="0"
                max="15"
                step="1"
                value={gapMm}
                onChange={(e) => setGapMm(Number(e.target.value))}
                className="w-full h-1.5 bg-gray-200 rounded-full appearance-none cursor-pointer accent-blue-500"
              />
              <div className="flex justify-between text-[9px] text-gray-400 mt-0.5">
                <span>0 mm</span>
                <span>15 mm</span>
              </div>
            </div>
            <button
              onClick={handleCreateLayout}
              disabled={!selectedLayout}
              className={`selenny-btn-primary w-full text-sm flex items-center justify-center gap-2 ${!selectedLayout ? 'opacity-40 cursor-not-allowed' : ''}`}
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
              Layout anwenden
            </button>
          </>
        )}
        {activeTab === 'number' && (
          <button
            onClick={handleCreateNumber}
            disabled={!numberInput}
            className={`selenny-btn-primary w-full text-sm flex items-center justify-center gap-2 ${!numberInput ? 'opacity-40 cursor-not-allowed' : ''}`}
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
            Zahlencollage erstellen
          </button>
        )}
      </div>
    </div>
  );
}

export default CollagePanel;
